import { FC, memo, useCallback, useState } from 'react'

import { useGetAiCreditRemainingQuery } from '@crew/apis/contract/contractApis'
import { useGetTenantQuery } from '@crew/apis/tenantSetting/tenantSettingApis'
import { UpdatedAiCredit } from '@crew/apis/websocket/models/updatedAiCredit/updatedAiCredit'
import { useSubscribeUpdatedAiCredit } from '@crew/providers/websocket'
import {
  CrewGuideToolTip,
  ToolTipTypes,
} from 'components/devextreme/crewGuideToolTip/crewGuideToolTip'

export const AiCreditRemaining: FC = memo(() => {
  const [updatedAiCreditCount, setUpdatedAiCreditCount] =
    useState<UpdatedAiCredit | null>(null)

  // AIクレジット残量をAPIで取得する
  const { data: getAiCreditRemainingResult } = useGetAiCreditRemainingQuery()

  // テナント情報取得API
  const { data: getTenant } = useGetTenantQuery()

  // 単なる分割代入なのでmemoしない
  const tenantId = getTenant?.tenant?.id

  // websocketでクレジットの更新を受信する
  const handleRecvMessage = useCallback((payload: UpdatedAiCredit) => {
    setUpdatedAiCreditCount((prev) => {
      // 受信したメッセージの更新シリアルが現在の状態より新しい場合のみ更新する
      if (prev === null || payload.updateSerial > prev.updateSerial) {
        return {
          updateSerial: payload.updateSerial,
          aiCredit: payload.aiCredit,
        }
      } else {
        return prev
      }
    })
  }, [])
  useSubscribeUpdatedAiCredit(tenantId, handleRecvMessage)

  // 表示する残クレジット数。単なる値の切り替えなのでmemoしない
  const displayAiCredit =
    updatedAiCreditCount?.aiCredit ?? // websocket経由で受信したクレジット数がある場合はそれを使う
    getAiCreditRemainingResult?.remainingAiCreditCount // websocket経由で受信したクレジット数がない場合はAPIから取得したクレジット数を使う

  return (
    <div id="ai-credit-remaining">
      AI:{displayAiCredit ?? '-'}
      <CrewGuideToolTip
        target="#ai-credit-remaining"
        position="bottom"
        type={ToolTipTypes.aiCreditRemaining}
      />
    </div>
  )
})
